<div mat-dialog-content class="dialog_body">
  <mat-icon color="primary">error_outlined</mat-icon>
  <h1>{{ data.title | translate }}</h1>
  <P> {{ data.description | translate }} </P>
</div>
<div mat-dialog-actions class="dialog_footer">
  <button mat-button color="primary" [mat-dialog-close]="false" cdkFocusInitial>
    {{ 'GENERAL.CANCEL' | translate }}
  </button>
  <button mat-flat-button [mat-dialog-close]="true" color="warn">
    {{ 'GENERAL.CONFIRM' | translate }}
  </button>
</div>
